<div class="inscricao-form-shell">
<!-- Pré-inscrição: a faixa etária da data atual não aceita mais ninguém. A ficha fica na tela,
     para não apagar o que já foi digitado, e o envio é recusado. -->
<div class="bloqueio-vaga" *ngIf="bloqueio">
    <nb-icon pack="eva" icon="alert-triangle-outline"></nb-icon>
    <span>{{ bloqueio }}</span>
</div>
<div class="row mt-3" *ngIf="finalizado">
    <div class="col-lg-12">
        <nb-card>
            <nb-card-header>Cadastro finalizado</nb-card-header>
            <nb-card-body>
                O cadastro foi finalizado com sucesso.
                <p class="aviso-email" *ngIf="ehPreInscricao">
                    Você receberá um e-mail com o horário de confirmação de sua inscrição, atente-se à
                    caixa de spam, caso não receba refaça sua pré-inscrição!
                </p>
                <p class="atendimento" *ngIf="atendimento">
                    Seu atendimento: <strong>{{ atendimento }}</strong>
                </p>
            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row mt-3" *ngIf="!finalizado">
    <div class="col-lg-12">
        <nb-card>
            <nb-card-header>Catequizando <ng-container *ngIf="isAdulto()"> Adulto {{getIdade()}} anos </ng-container>
                <ng-container *ngIf="isCrianca()"> Criança ou Adolescente {{getIdade()}} anos </ng-container>
            </nb-card-header>
            <nb-card-body>
                <label for="cpfCatequizando">CPF *</label>
                <input nbInput fullWidth id="cpfCatequizando" [(ngModel)]="inscricao.cpfCatequizando" [mask]="mascaras.cpf"
                    name="cpfCatequizando"
                    (ngModelChange)="aoDigitarCpfCatequizando($event)"
                    (blur)="buscarDadosPorCpf(inscricao.cpfCatequizando, 'catequizando')" />
                <small class="dica-consulta" *ngIf="carregando.catequizando">Consultando o CPF…</small>

                <nb-spinner *ngIf="carregando.catequizando" size="tiny" status="primary"
                    style="position: absolute; right: 10px; top: 36px;"></nb-spinner>

                <label for="nomeCatequizando">Nome do Catequizando *</label>
                <input nbInput fullWidth id="nomeCatequizando" [(ngModel)]="inscricao.nomeCatequizando"
                    name="nomeCatequizando" [readonly]="nomeTravadoPorCpf"
                    [attr.aria-readonly]="nomeTravadoPorCpf ? true : null" />
                <small class="dica-consulta" *ngIf="nomeTravadoPorCpf">Veio do CPF consultado.</small>

                <label for="dataNascimento">Data de Nascimento *</label>
                <input nbInput fullWidth type="date" id="dataNascimento" [(ngModel)]="inscricao.dataNascimento"
                    name="dataNascimento" [readonly]="dataNascimentoTravadaPorCpf"
                    (ngModelChange)="aoMudarDataNascimento($event)"
                    [attr.aria-readonly]="dataNascimentoTravadaPorCpf ? true : null" />
                <small class="dica-consulta" *ngIf="dataNascimentoTravadaPorCpf">Veio do CPF consultado.</small>

            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row" *ngIf="isTemCatequizando()">
    <div class="col-lg-6">
        <nb-card>
            <nb-card-header>Dados do Catequizando</nb-card-header>
            <nb-card-body>
                <label for="sexoCatequizando">Sexo *</label>
                <nb-select id="sexoCatequizando" placeholder="Selecione o sexo do catequizando" fullWidth
                    [(selected)]="inscricao.sexo">
                    <nb-option value="M">Masculino</nb-option>
                    <nb-option value="F">Feminino</nb-option>
                </nb-select>


                <label for="celularCatequizando">Celular</label>
                <input nbInput fullWidth id="celularCatequizando" [(ngModel)]="inscricao.celularCatequizando" [mask]="mascaras.telefone"
                    name="celularCatequizando" />

                <label for="emailCatequizando">Email</label>
                <input nbInput fullWidth id="emailCatequizando" type="email" [(ngModel)]="inscricao.emailCatequizando"
                    name="emailCatequizando" />

                <!-- Estado civil só faz sentido para adulto. O rótulo carrega a mesma condição
                     do campo: separados, ele aparecia sozinho para adolescente. -->
                <ng-container *ngIf="isAdulto()">
                <label for="estadoCivil">Estado Civil</label>
                <nb-select id="estadoCivil" placeholder="Selecione o estado civil" fullWidth
                    [(selected)]="inscricao.estadoCivil">
                    <nb-option value="solteiro">Solteiro(a)</nb-option>
                    <nb-option value="casado">Casado(a)</nb-option>
                    <nb-option value="separado">Separado(a)</nb-option>
                    <nb-option value="divorciado">Divorciado(a)</nb-option>
                    <nb-option value="viuvo">Viúvo(a)</nb-option>
                    <nb-option value="uniao_estavel">União Estável</nb-option>
                </nb-select>
                </ng-container>

                <label for="escolaridade">Escolaridade</label>
                <nb-select id="escolaridade" placeholder="Selecione a escolaridade" fullWidth [(selected)]="inscricao.escolaridade">
                    <nb-option value="nao_alfabetizado">Não Alfabetizado</nb-option>
                    <nb-option value="fundamental_incompleto">Ensino Fundamental Incompleto</nb-option>
                    <nb-option value="fundamental_completo">Ensino Fundamental Completo</nb-option>
                    <nb-option value="medio_incompleto">Ensino Médio Incompleto</nb-option>
                    <nb-option value="medio_completo">Ensino Médio Completo</nb-option>
                    <nb-option value="superior_incompleto">Ensino Superior Incompleto</nb-option>
                    <nb-option value="superior_completo">Ensino Superior Completo</nb-option>
                    <nb-option value="pos_graduacao">Pós-graduação</nb-option>
                    <nb-option value="mestrado">Mestrado</nb-option>
                    <nb-option value="doutorado">Doutorado</nb-option>
                </nb-select>

            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row" *ngIf="isTemCatequizando()">
    <div class="col-lg-6">
        <nb-card>
            <nb-card-header>Sacramentos do Catequizando</nb-card-header>
            <nb-card-body>
                <label id="rotuloBatizado">Batizado<ng-container *ngIf="ehPreInscricao"> *</ng-container></label>
                <nb-radio-group name="batizado" aria-labelledby="rotuloBatizado" class="opcoes-batismo"
                    [(ngModel)]="inscricao.batizado" (valueChange)="aoMudarBatizado($event)">
                    <nb-radio [value]="true">Sim</nb-radio>
                    <nb-radio [value]="false">Não</nb-radio>
                </nb-radio-group>

                <ng-container *ngIf="inscricao.batizado">
                    <label id="rotuloIgrejaBatismo">Igreja do batismo<ng-container *ngIf="ehPreInscricao"> *</ng-container></label>
                    <nb-radio-group name="igrejaBatismo" aria-labelledby="rotuloIgrejaBatismo" class="opcoes-batismo"
                        [(ngModel)]="inscricao.igrejaBatismo" (valueChange)="aoMudarIgrejaBatismo($event)">
                        <nb-radio value="catolica">Batizado em Igreja Católica Apostólica Romana</nb-radio>
                        <nb-radio value="nao_catolica">Batizado em Igreja não Católica</nb-radio>
                    </nb-radio-group>

                    <ng-container *ngIf="inscricao.igrejaBatismo === 'nao_catolica'">
                        <label for="nomeIgrejaBatismo">Em qual Igreja?<ng-container *ngIf="ehPreInscricao"> *</ng-container></label>
                        <input nbInput fullWidth id="nomeIgrejaBatismo" name="nomeIgrejaBatismo"
                            [(ngModel)]="inscricao.nomeIgrejaBatismo" />
                    </ng-container>
                </ng-container>

                <nb-checkbox *ngIf="inscricao.batizado" [(ngModel)]="inscricao.primeiraComunhao">Primeira Comunhão</nb-checkbox> <br/>
                <nb-checkbox *ngIf="inscricao.batizado && isAdulto()" [(ngModel)]="inscricao.matrimonio">Matrimônio</nb-checkbox> <br/>

                <label *ngIf="isAdulto() && inscricao.matrimonio" for="situacaoMatrimonio">Situação do Matrimônio</label>
                <nb-select *ngIf="isAdulto() && inscricao.matrimonio" id="situacaoMatrimonio" placeholder="Selecione a situação atual do seu matrimônio" fullWidth [(selected)]="inscricao.situacaoMatrimonio">
                    <nb-option value="primeira_uniao">Sou casado na Igreja Católica e vivo esta união até hoje</nb-option>
                    <nb-option value="nova_uniao">Fui casado na Igreja Católica mas hoje estou em uma nova união</nb-option>
                    <nb-option value="sem_matrimonio">Nunca fui casado na Igreja Católica</nb-option>
                </nb-select>
                <br/><br/>

            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row" *ngIf="isTemCatequizando()">
    <div class="col-lg-6">
        <nb-card>
            <nb-card-header>Necessidades especiais</nb-card-header>
            <nb-card-body>
                
                <label>O catequizando possui alguma destas necessidades especiais?</label><br/>
                <nb-checkbox [(ngModel)]="inscricao.alergico">Alérgico</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.diabetico">Diabético</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.intoleranteLactose">Intolerante a lactose</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.tdah">TDAH</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.autista">Autista</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.dislexo">Dislexo</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.tod">TOD</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.outros">Outros</nb-checkbox> <br/>
                
                <ng-container *ngIf="inscricao.outros">
                  <label for="necessidadeEspecialTxt">Descreva a necessidade</label>
                  <input nbInput fullWidth id="necessidadeEspecialTxt" [(ngModel)]="inscricao.necessidadeEspecialTxt"
                         name="necessidadeEspecialTxt" />
                </ng-container>


                

            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row" *ngIf="isTemCatequizando()">
    <div class="col-lg-6">
        <nb-card>
            <nb-card-header>Dados da Mãe</nb-card-header>
            <nb-card-body>
                <nb-checkbox [(ngModel)]="inscricao.maeSemCpf" (checkedChange)="onSemCpfChangePais($event)" *ngIf="isAdulto()">Não sei o CPF da Mãe</nb-checkbox> <br/>
                <label for="cpfMae">CPF da Mãe</label>
                <input nbInput fullWidth id="cpfMae" [(ngModel)]="inscricao.cpfMae"  [mask]="mascaras.cpf"
                    (ngModelChange)="aoDigitarCpfResponsavel($event, 'mae')"
                    (blur)="buscarDadosPorCpf(inscricao.cpfMae, 'mae')" />

                <nb-spinner *ngIf="carregando.mae" size="tiny" status="primary"
                    style="position: absolute; right: 10px; top: 36px;"></nb-spinner>

                <label for="nomeMae">Nome da Mãe</label>
                <input nbInput fullWidth id="nomeMae" placeholder="Digite o nome da mãe" [(ngModel)]="inscricao.nomeMae"
                    name="nomeMae" [readonly]="nomeMaeTravadoPorCpf"
                    [attr.aria-readonly]="nomeMaeTravadoPorCpf ? true : null" />
                <small class="dica-consulta" *ngIf="nomeMaeTravadoPorCpf">Veio do CPF consultado.</small>

                <label for="telefoneMae">Telefone da Mãe</label>
                <input nbInput fullWidth id="telefoneMae" placeholder="Telefone da mãe" [(ngModel)]="inscricao.telefoneMae" [mask]="mascaras.telefone"
                    name="telefoneMae" />

                <label for="emailMae">Email da Mãe</label>
                <input nbInput fullWidth id="emailMae" [(ngModel)]="inscricao.emailMae" 
                    name="emailMae" />

                </nb-card-body>
        </nb-card>
    </div>

    <div class="col-lg-6">
        <nb-card>
            <nb-card-header>Dados do Pai</nb-card-header>
            <nb-card-body>
                <nb-checkbox [(ngModel)]="inscricao.naoConstaPai" (checkedChange)="onSemCpfChangePais($event)">Não declarado em documento</nb-checkbox> <br/>
                <nb-checkbox [(ngModel)]="inscricao.paiSemCpf" (checkedChange)="onSemCpfChangePais($event)" *ngIf="isAdulto()">Não sei o CPF do Pai</nb-checkbox> <br/>
                <label for="cpfPai">CPF do Pai</label>
                <input nbInput fullWidth id="cpfPai" placeholder="Digite o CPF" [(ngModel)]="inscricao.cpfPai"  [mask]="mascaras.cpf"
                    name="cpfPai"
                    (ngModelChange)="aoDigitarCpfResponsavel($event, 'pai')"
                    (blur)="buscarDadosPorCpf(inscricao.cpfPai, 'pai')" />

                <nb-spinner *ngIf="carregando.pai" size="tiny" status="primary"
                    style="position: absolute; right: 10px; top: 36px;"></nb-spinner>


                <label for="nomePai">Nome do Pai</label>
                <input nbInput fullWidth id="nomePai" placeholder="Digite o nome do pai" [(ngModel)]="inscricao.nomePai"
                    name="nomePai" [readonly]="nomePaiTravadoPorCpf"
                    [attr.aria-readonly]="nomePaiTravadoPorCpf ? true : null" />
                <small class="dica-consulta" *ngIf="nomePaiTravadoPorCpf">Veio do CPF consultado.</small>

                <label for="telefonePai">Telefone do Pai</label>
                <input nbInput fullWidth id="telefonePai" placeholder="Telefone do pai" [(ngModel)]="inscricao.telefonePai" [mask]="mascaras.telefone"
                    name="telefonePai" />

                <label for="emailPai">Email do Pai</label>
                <input nbInput fullWidth id="emailPai" [(ngModel)]="inscricao.emailPai" 
                    name="emailPai" />

            </nb-card-body>
        </nb-card>
    </div>
</div>

<div class="row mt-3" *ngIf="isTemCatequizando()">
    <div class="col-lg-12">
        <nb-card>
            <nb-card-header>Endereço onde mora o catequizando</nb-card-header>
            <nb-card-body>
                <label for="cep">CEP *</label>
                <input nbInput fullWidth id="cep" placeholder="CEP"
                    [(ngModel)]="inscricao.cep"
                    (blur)="buscarEnderecoPorCep()" [mask]="mascaras.cep"
                    name="cep" />

                <label for="endereco">Endereço</label>
                <input nbInput fullWidth id="endereco" placeholder="Rua, número..." [(ngModel)]="inscricao.endereco"
                    name="endereco" />

                <label for="bairro">Bairro</label>
                <input nbInput fullWidth id="bairro" placeholder="Bairro" [(ngModel)]="inscricao.bairro"
                    name="bairro" />

                <label for="complemento">Complemento</label>
                <input nbInput fullWidth id="complemento" placeholder="Complemento" [(ngModel)]="inscricao.complemento"
                    name="complemento" />

                <label for="municipioId">Municipio</label>
                <input nbInput fullWidth id="municipio" placeholder="Município" [(ngModel)]="inscricao.municipio"
                    name="municipio" />
            </nb-card-body>
        </nb-card>
    </div>
</div>

<button nbButton status="primary" fullWidth class="btn-salvar-inscricao" (click) = "salvar()" *ngIf="!finalizado">Salvar</button>
</div>

<!-- Overlay de salvamento animado -->
<div class="overlay-salvamento" *ngIf="salvando">
  <div class="overlay-conteudo">
    <div class="spinner-salvamento"></div>
    <p class="mensagem-progresso">{{ mensagemProgresso }}</p>
    <div class="barra-progresso">
      <div class="barra-progresso-fill"></div>
    </div>
  </div>
</div>

<!-- Mensagem de erro fixa -->
<div class="overlay-erro" *ngIf="erroSalvamento">
  <div class="overlay-erro-conteudo">
    <div class="overlay-erro-icon">!</div>
    <h3>Erro ao salvar</h3>
    <p>{{ erroSalvamento }}</p>
    <button nbButton status="danger" (click)="fecharErro()">Fechar</button>
  </div>
</div>